import { Card, Container } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";

import VerifyFailure from "./VerifyFailure";
import VerifySuccess from "./VerifySuccess";

import userService from "../../../../services/user";
import * as tokenService from "../../../../services/token";

import { RootState, useAppDispatch } from "../../../../redux/store";
import { setLoadingAction } from "../../../../redux/utils/actions";

import IMAGES from "../../../../assets/themes/images/images";
import styles from "../login.module.scss";

const VerifyEmail: FC = (): JSX.Element => {
  const [isEmailVerified, setIsEmailVerified] = useState(false);

  const [searchParams] = useSearchParams();

  const dispatch = useAppDispatch();

  const { loading } = useSelector((state: RootState) => state.utils);

  useEffect(() => {
    const token = searchParams.get("token");
    const verifyUser = async () => {
      try {
        dispatch(setLoadingAction(true));
        if (token) {
          await userService.verify({ token });
          tokenService.setAccessToken(token);
          setIsEmailVerified(true);
        }
        dispatch(setLoadingAction(false));
      } catch (err) {
        dispatch(setLoadingAction(false));
      }
    };
    verifyUser();
  }, [dispatch, searchParams]);

  return (
    <Container>
      <div className={`${styles.loginWrap} ${styles.formSpaceTop}`}>
        <div className={styles.logoWrap}>
          <img className={styles.logoLogin} src={IMAGES.Logo} alt="logo" />
        </div>

        {loading ? (
          <h1 className="text-center">Loading....</h1>
        ) : (
          <Card className={styles.loginCard} variant="outlined">
            <div className={styles.cardBody}>
              {isEmailVerified ? <VerifySuccess /> : <VerifyFailure />}
            </div>
          </Card>
        )}
      </div>
    </Container>
  );
};

export default VerifyEmail;
